import { Component } from '@angular/core';
import { ThemeService } from './services/theme.service';
import { CustomTranslateService } from './services/translate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  // Injecting these services here triggers their constructors at app bootstrap,
  // before any route renders:
  //   - ThemeService reads localStorage and applies the persisted theme.
  //   - CustomTranslateService calls translate.use(getInitLanguage()) in its
  //     constructor, which triggers the HTTP fetch of assets/i18n/<lang>.json.
  //     Without an explicit injection here, the service is constructed only
  //     when something in a route lazily injects it (e.g. the cabinet
  //     ThemeSwitcherComponent). Lazy routes that don't otherwise touch it —
  //     /owner-login, /owner — would then render with raw translation keys
  //     ("owner.login.title", ...) because no locale has ever been selected
  //     on the ngx-translate TranslateService.
  constructor(_themeService: ThemeService, _translate: CustomTranslateService) {}
}
